import React, { useEffect, useState } from 'react';
import { useErrorInputs } from '../../../../hooks/useErrorInputs';
import { useForm } from '../../../../hooks/useForm';
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import InputLabel from "@mui/material/InputLabel";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import Switch from "@mui/material/Switch";
import Select from "@mui/material/Select";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { Cancel, ExpandLess, ExpandMore, PostAdd, Save } from '@mui/icons-material';

import TableActionBasic from '../TableActionBasic';
import { ManageActions } from './ManageActions';
import { TABLE_COLUMN_TYPE_OPTIONS, createInitialMenuColumn } from '../../constants/interface.constants';
import { sanitizeAction } from '../../helpers/helpers';

export const MenuAndSubmenu = ({ data, typeAction, handleSave, handleCloseModal, t, action}) => {
    const [columns, setColumns] = useState([]);
    const [col, setCol] = useState(createInitialMenuColumn('id'));
    const [editingIndex, setEditingIndex] = useState(null);
    const [visibleTable, setvisibleTable] = useState(true);
    const [errorInputs, , , validForm] = useErrorInputs({});
    //#region table
    const handleInputChange = ({ target }) => {
        setCol((prevValueInputs) => ({
            ...prevValueInputs,
            [target.name]: target.value
        }));
    }

    const resetColumnForm = () => {
        setCol(createInitialMenuColumn(''));
        setEditingIndex(null);
    };

    const handleSaveColumn = () => {
        const requiredFields = ['id', 'label'];
        if (!validForm(requiredFields, col))
            return false;

        if (editingIndex !== null) {
            setColumns(prevItems => prevItems.map((item, idx) => (
                idx === editingIndex ? { ...col } : item
            )));
        } else {
            if (columns.some((item) => item.id === col.id)) {
                return false;
            }
            setColumns(prevItems => [...prevItems, col]);
        }
        resetColumnForm();
    };

    const handleEditColumn = (_, idx) => {
        setCol({ ...columns[idx] });
        setEditingIndex(idx);
        setvisibleTable(true);
    };

    const handleDelete = (id, idx) => {
        setColumns(prevItems => prevItems.filter((_, i) => i !== idx));
        if (editingIndex === idx)
            resetColumnForm();
        else if (editingIndex !== null && idx < editingIndex)
            setEditingIndex(editingIndex - 1);
    };

    const handleMoveColumn = (fromIndex, toIndex) => {
        if (toIndex < 0 || toIndex >= columns.length) return;
        setColumns(prevItems => {
            const next = [...prevItems];
            const [moved] = next.splice(fromIndex, 1);
            next.splice(toIndex, 0, moved);
            return next;
        });
        if (editingIndex === fromIndex)
            setEditingIndex(toIndex);
        else if (editingIndex !== null) {
            if (fromIndex < editingIndex && toIndex >= editingIndex)
                setEditingIndex(editingIndex - 1);
            else if (fromIndex > editingIndex && toIndex <= editingIndex)
                setEditingIndex(editingIndex + 1);
        }
    };

    const handleMoveUp = (idx) => handleMoveColumn(idx, idx - 1);
    const handleMoveDown = (idx) => handleMoveColumn(idx, idx + 1);

    useEffect(() => {
        handleSave('table', columns);
    }, [columns, handleSave]);

    //#endregion

    //#region actions
    const [listActions, setListActions] = useState([]);
    const [valuesAction, handleInputChangeForm, handleDirectInputChangeForm, , reset] = useForm({
        accion: '',
        type: '',
        icon: '',
        color: ''
    });
    const [errorInputsB, , , validFormB] = useErrorInputs({});

    const validateFormB = () => {
        const requiredFields = ["accion", "icon", 'color', 'type'];
        return validFormB(requiredFields, valuesAction);
    };

    const handleDeleteAct = (index) => {
        setListActions(prevItems => prevItems.filter((_, i) => i !== index));
        reset();
    }

    const handleAddActoin = () => {
        if (validateFormB()) {
            setListActions(prevItems => [...prevItems, sanitizeAction(valuesAction)]);
            reset();
        }
    }

    useEffect(() => {
        handleSave('button', listActions);
    }, [listActions, handleSave]);
    //#endregion

    useEffect(() => {
        if (data?.button)
            setListActions(data.button)
        if (data?.table)
            setColumns(data.table);
    }, [])


    return (
        <>
            {action === 'listColumns' &&
                <>    
                    <Box sx={{ mt: 2 }}>
                        <Grid container spacing={2} alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
                            <Grid size={{xs:10, sm:'auto'}}>
                                <Typography variant='h6' component='h6'>
                                    {t("common.tableColumnsTitle")}
                                </Typography>
                            </Grid>
                            <Grid 
                                size={{xs:2, sm:'auto'}}         
                                sx={{
                                    display: "flex",
                                    justifyContent: { xs: "flex-start", sm: "flex-end" },
                                    gap: 1
                                }}
                            >
                                {editingIndex !== null && (
                                    <Tooltip title={t('cancel')}>
                                        <IconButton onClick={resetColumnForm} color="warning">
                                            <Cancel />
                                        </IconButton>
                                    </Tooltip>
                                )}
                                <Tooltip title={editingIndex !== null ? t('save') : t('add')}>
                                    <IconButton onClick={handleSaveColumn} color="primary">
                                        {editingIndex !== null ? <Save /> : <PostAdd />}
                                    </IconButton>
                                </Tooltip>
                                {columns.length > 0 && (
                                    <Tooltip title={visibleTable ? t('hide') : t('show')}>
                                        <IconButton
                                            onClick={() => setvisibleTable(!visibleTable)}
                                        >
                                            {visibleTable ? <ExpandLess /> : <ExpandMore />}
                                        </IconButton>
                                    </Tooltip>
                                )}
                            </Grid>
                        </Grid>

                        {editingIndex !== null && (
                            <Typography variant="caption" color="primary" sx={{ display: 'block', mb: 1 }}>
                                Editando columna: {columns[editingIndex]?.label}
                            </Typography>
                        )}

                        <Grid container spacing={2}>
                            <Grid size={{xs:12, sm:6}}>
                                <TextField required fullWidth size='small' variant='outlined' name='id' label='Id columna'
                                    error={errorInputs.id?.isError}
                                    color={(errorInputs.id?.isError) && 'error'}
                                    helperText={errorInputs.id?.messageError || ''}
                                    disabled={editingIndex !== null && columns[editingIndex]?.id === 'id'}
                                    value={col.id}
                                    onChange={handleInputChange}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                            <Grid size={{xs:12, sm:6}}>
                                <TextField required fullWidth size='small' variant='outlined' name='label' label='Nombre de la columna'
                                    error={errorInputs.label?.isError}
                                    color={(errorInputs.label?.isError) && 'error'}
                                    helperText={errorInputs.label?.messageError || ''}
                                    value={col.label}
                                    onChange={handleInputChange}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                            <Grid size={{xs:12, sm:6}}>
                                <FormControl fullWidth required size='small'>
                                    <InputLabel id="type">{t('commonFields.type')}</InputLabel>
                                    <Select label={t('commonFields.type')} name='type'
                                        value={col.type}
                                        onChange={handleInputChange}
                                    >
                                        {TABLE_COLUMN_TYPE_OPTIONS.map((option, idx) => <MenuItem key={idx} value={option}>{option}</MenuItem>)}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid size={{xs:12, sm:3}}>
                                <FormControlLabel
                                    labelPlacement="top"
                                    control={
                                        <Switch id='filterable' name='filterable'
                                            onChange={(e) => handleInputChange({target: { name: e.target.name, value: e.target.checked }})}
                                            checked={col.filterable}
                                            disabled={col.id === 'id'}
                                        />
                                    }
                                    label={'Filterable'}
                                />
                            </Grid>
                            <Grid size={{xs:12, sm:3}}>
                                <FormControlLabel
                                    labelPlacement="top"
                                    control={
                                        <Switch id='visible' name='visible'
                                            onChange={(e) => handleInputChange({target: { name: e.target.name, value: e.target.checked }})}
                                            checked={col.visible}
                                        />
                                    }
                                    label={'Visible'}
                                />
                            </Grid>
                        </Grid>
                    </Box>

                    {columns.length > 0 && visibleTable &&
                        <TableActionBasic
                            columns={[
                                { label: 'Nombre', id: 'label' },
                                { label: 'Id', id: 'id' },
                                { label: 'Tipo', id: 'type' },
                                { label: 'Filterable', id: 'filterable' },
                                { label: 'Visible', id: 'visible' },
                            ]}
                            values={columns}
                            handleDelete={handleDelete}
                            handleEdit={handleEditColumn}
                            onMoveUp={handleMoveUp}
                            onMoveDown={handleMoveDown}
                            editingIndex={editingIndex}
                            t={t}
                        />
                    }
                </>

            }
            {action === 'createButton' &&
                <>
                    <ManageActions
                        values={valuesAction}
                        errorInputs={errorInputsB}
                        listActions={true}
                        handleInputChange={handleInputChangeForm}
                        handleDirectInputChange={handleDirectInputChangeForm}
                        handleCloseModal={handleCloseModal}
                        handleAdd={handleAddActoin}
                        t={t}
                    />

                    {listActions.length > 0 &&
                        <TableActionBasic
                            columns={[
                                { label: 'Nombre', id: 'accion' },
                                { label: 'Tipo', id: 'type' }
                            ]}
                            values={listActions}
                            handleDelete={(id, idx) => handleDeleteAct(idx)}
                            t={t}
                        />
                    }
                </>
            }
        </>
    );
}
